/**
 * Clip y micrófono del compositor de Sol (los dos compositores usan esto).
 * Grabar termina enviando: `onNotaDeVoz` recibe el audio ya grabado.
 */
import { useState } from 'react';

import { VoiceRecorder } from '@/features/shared/components/VoiceRecorder';

import { BotonAdjuntarImagen } from './AdjuntosDeImagen';

export function AccionesDeAdjunto({
  onArchivos,
  onNotaDeVoz,
  disabled,
}: {
  onArchivos: (archivos: File[]) => void;
  onNotaDeVoz: (blob: Blob, duracionMs: number) => void;
  disabled?: boolean;
}) {
  const [grabando, setGrabando] = useState(false);
  return (
    <div className="flex items-center gap-0.5">
      {!grabando && <BotonAdjuntarImagen onArchivos={onArchivos} disabled={disabled} />}
      {/* VoiceRecorder dibuja botones sin estilo propio: se los da este contenedor. */}
      <div className="[&_button]:text-muted-foreground [&_button:hover]:text-foreground [&_button]:inline-flex [&_button]:size-7 [&_button]:items-center [&_button]:justify-center [&_button]:rounded-md [&_button:disabled]:opacity-50">
        <VoiceRecorder
          disabled={disabled}
          grabando={grabando}
          onGrabandoChange={setGrabando}
          onGrabada={(blob, _nombre, duracionMs) => onNotaDeVoz(blob, duracionMs)}
        />
      </div>
    </div>
  );
}
